<div >
  <app-button [text]="'arrow_back'" [matButtonAparence]="'tonal'" [href]="'/'+backUrl()" [typeButton]="'icon'" ></app-button>
</div>
<ng-container *ngTemplateOutlet="templateRef;"></ng-container>
